<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">Добавить адрес</h1>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'district-details', params: { district_id: $route.params.district_id } }">← Назад к Адресам</router-link>
    </div>

    <address-add-form :district="+$route.params.district_id" @after="handleAfter" />

  </div>
</template>

<script>
import addressAddForm from '@/components/forms/address/AddressAddForm'

export default {
  name: 'address-add',
  components: { addressAddForm },
  methods: {
    handleAfter (success) {
      if (success) {
        this.$router.push({ name: 'district-details', params: { district_id: this.$route.params.district_id } })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// AddressAdd.vue?37cd295b